import {User} from "@/models/user";

export class ElectronicBadge {
    constructor(id = 0, location = '', radius = '', employee = new User()) {
        this.id = id;
        this.location = location;
        this.radius = radius;
        this.employee = employee
    }
}